import { type DocumentNode, gql } from '@apollo/client';

const deleteMediaPermission: DocumentNode = gql`
  mutation delete_media_permission($mediaPermissionId: ID!) {
    deleteMediaPermission(mediaPermissionId: $mediaPermissionId) {
      mediaPermission {
        profile {
          firstName
          lastName
        }
        permissionsGroup {
          name
        }
      }
    }
  }
`;

export default deleteMediaPermission;
